import { Group } from '@/config/types';
import constants from '@/config/constants';

export const getUserGroup = () => {
  const userLogged = sessionStorage.getItem('userLogged');

  if (!userLogged) return null;

  const { groups } = JSON.parse(userLogged);
  const { roles: { produtor, frigorifico, admin } } = constants;

  let groupName = '';

  const isProd = groups.filter((group: Group) => group.stName.toLowerCase().includes(produtor));
  const isFrig = groups.filter((group: Group) => group.stName.toLowerCase().includes(frigorifico));
  const isAdmin = groups.filter((group: Group) => group.stName.toLowerCase().includes(admin));

  if (isProd.length) {
    groupName = produtor;
  }

  if (isFrig.length) {
    groupName = frigorifico;
  }

  if (isAdmin.length) {
    groupName = admin;
  }

  return groupName;
};

export default getUserGroup;
